import geoManager from '../services/geo/geoManager';
import globalConsent from '../ads/gdpr/globalConsent';

export default async function getGeoData() {
  const geoModel = await geoManager();
  globalConsent.geo = geoModel.geo;
}
